import { components, OptionProps } from 'react-select';
import Icon from './Icon';
import { DestinationTypes } from '../../../shared/constants';
import { SelectOption } from '../../../shared/models/form';

const CustomOption = (props: OptionProps<SelectOption>) => {
  const { type, state, multipleAirports, country, name } = props.data.location;
  const { CITY, FNF, FNR } = DestinationTypes;
  const allAirports = 'All Airports';
  const stateText = state ? `, ${state}` : '';
  const allAirportsText = type === CITY && multipleAirports ? ` (${allAirports})` : '';
  const displayCheckmark = props.isFocused;
  return (
    <components.Option {...props}>
      <div className="flex">
        <div className="w-6 h-6 absolute left-4 text-gray-500">
          {displayCheckmark && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
          )}
        </div>

        <div className="flex justify-between w-full">
          <span>
            {name}
            {allAirportsText}
            <span className="text-input-gray">
              , {country}
              {stateText}
            </span>
          </span>
          {(type === FNF || type === FNR) && <Icon type={type} />}
        </div>
      </div>
    </components.Option>
  );
};

export default CustomOption;
